import QuadranteSwot from '../types/negocio/QuadranteSwot';
import Swot from '../types/negocio/Swot';
import api from './api';
import BaseService from './BaseService';

export interface SwotAnaliseIa {
    resumoEstrategico: string;
    estrategiasSO: string[];
    estrategiasWT: string[];
    topRecomendacoes: string[];
    insight: string;
    cenario: 'FAVORAVEL' | 'DESFAVORAVEL';
    dataGeracao: string;
}

class SwotService extends BaseService<Swot> {

    constructor() {
        super('swot', api);
    }

    obterQuadrante(): Promise<QuadranteSwot> {
        return super.listarTodos().then(data => {
            return {
                pontosFortes: data.filter(item => item.quadrante === 'S').sort((a, b) => b.pontuacao - a.pontuacao),
                pontosFracos: data.filter(item => item.quadrante === 'W').sort((a, b) => b.pontuacao - a.pontuacao),
                oportunidades: data.filter(item => item.quadrante === 'O').sort((a, b) => b.pontuacao - a.pontuacao),
                ameacas: data.filter(item => item.quadrante === 'T').sort((a, b) => b.pontuacao - a.pontuacao)
            };
        });
    }

    async gerarAnaliseIa(): Promise<SwotAnaliseIa> {
        const response = await api.post<SwotAnaliseIa>('/api/swot/analise-ia');
        return response.data;
    }

}

export const swotService = new SwotService();